import { render, staticRenderFns } from "./InnerRouter.vue?vue&type=template&id=2cb32c97&"
import script from "./InnerRouter.vue?vue&type=script&lang=js&"
export * from "./InnerRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports